export enum Lng {
  LV = 'lv',
  EN = 'en',
}

export enum EmitStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum ActionType {
  GET = 'GET',
  SEND = 'SEND',
}

export enum Direction {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum BlockType {
  BIG = 'BIG',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

export enum Color {
  GRAY = 'gray',
}

export enum Orientation {
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
}
